import createTableStore from "ds/components/Table/store/useTableStore";

import {
  MODULE_VERSION_PROVIDER_DEPENDENCIES_TABLE_COLUMNS_CONFIG,
  MODULE_VERSION_PROVIDER_DEPENDENCIES_TABLE_STORAGE_KEY,
} from "./constants";

const useModuleVersionProviderDependenciesTableStore = createTableStore({
  storageKey: MODULE_VERSION_PROVIDER_DEPENDENCIES_TABLE_STORAGE_KEY,
  config: MODULE_VERSION_PROVIDER_DEPENDENCIES_TABLE_COLUMNS_CONFIG,
});

export default useModuleVersionProviderDependenciesTableStore;
